import { createContext, useContext } from 'react';
import { Optional } from '@/generic/functional';
import { Progress } from '@/generic/progress';
import type { DiagnosticCompleted } from '@/diagnostic/domain/Diagnostic.ts';
import type { ApiInformationToDiagnose } from '@/diagnostic/domain/ApiInformation.ts';

export type DiagnosticTrackingToast = { kind: 'success' } | { kind: 'failure' };

export type DiagnosticTracking = {
  isLoading: boolean;
  modalVisible: boolean;
  progress: Optional<Progress>;
  failure: Optional<Error>;
  diagnosticCompleted: Optional<DiagnosticCompleted>;
  reportOpen: boolean;
  toast: Optional<DiagnosticTrackingToast>;
  start: (api: ApiInformationToDiagnose) => void;
  retry: () => void;
  stop: () => void;
  continueInBackground: () => void;
  reopen: () => void;
  openReport: () => void;
  closeReport: () => void;
  dismissToast: () => void;
  notifyPageMounted: (mounted: boolean) => void;
};

export const DiagnosticTrackingReactContext = createContext<Optional<DiagnosticTracking>>(
  Optional.empty(),
);

export const useDiagnosticTracking = (): DiagnosticTracking =>
  useContext(DiagnosticTrackingReactContext).orElseThrow(
    () => new Error('useDiagnosticTracking must be used within a DiagnosticTrackingProvider'),
  );
